"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.approveUseAuthority = exports.getApproveUseAuthorityInstructionDataSerializer = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const serializers_1 = require("@metaplex-foundation/umi/serializers");
const accounts_1 = require("../accounts");
const shared_1 = require("../shared");
function getApproveUseAuthorityInstructionDataSerializer() {
    return (0, serializers_1.mapSerializer)((0, serializers_1.struct)([
        ['discriminator', (0, serializers_1.u8)()],
        ['numberOfUses', (0, serializers_1.u64)()],
    ], { description: 'ApproveUseAuthorityInstructionData' }), (value) => ({ ...value, discriminator: 20 }));
}
exports.getApproveUseAuthorityInstructionDataSerializer = getApproveUseAuthorityInstructionDataSerializer;
// Instruction.
function approveUseAuthority(context, input) {
    // Program ID.
    const programId = context.programs.getPublicKey('mplTokenMetadata', 'metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s');
    // Accounts.
    const resolvedAccounts = {
        useAuthorityRecord: {
            index: 0,
            isWritable: true,
            value: input.useAuthorityRecord ?? null,
        },
        owner: {
            index: 1,
            isWritable: true,
            value: input.owner ?? null,
        },
        payer: {
            index: 2,
            isWritable: true,
            value: input.payer ?? null,
        },
        user: { index: 3, isWritable: false, value: input.user ?? null },
        ownerTokenAccount: {
            index: 4,
            isWritable: true,
            value: input.ownerTokenAccount ?? null,
        },
        metadata: {
            index: 5,
            isWritable: false,
            value: input.metadata ?? null,
        },
        mint: { index: 6, isWritable: false, value: input.mint ?? null },
        burner: {
            index: 7,
            isWritable: false,
            value: input.burner ?? null,
        },
        tokenProgram: {
            index: 8,
            isWritable: false,
            value: input.tokenProgram ?? null,
        },
        systemProgram: {
            index: 9,
            isWritable: false,
            value: input.systemProgram ?? null,
        },
        rent: {
            index: 10,
            isWritable: false,
            value: input.rent ?? null,
        },
    };
    // Arguments.
    const resolvedArgs = { ...input };
    // Default values.
    if (!resolvedAccounts.payer.value) {
        resolvedAccounts.payer.value = context.payer;
    }
    if (!resolvedAccounts.metadata.value) {
        resolvedAccounts.metadata.value = (0, accounts_1.findMetadataPda)(context, {
            mint: (0, shared_1.expectPublicKey)(resolvedAccounts.mint.value),
        });
    }
    if (!resolvedAccounts.tokenProgram.value) {
        resolvedAccounts.tokenProgram.value = context.programs.getPublicKey('splToken', 'TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA');
        resolvedAccounts.tokenProgram.isWritable = false;
    }
    if (!resolvedAccounts.systemProgram.value) {
        resolvedAccounts.systemProgram.value = context.programs.getPublicKey('splSystem', '11111111111111111111111111111111');
        resolvedAccounts.systemProgram.isWritable = false;
    }
    // Accounts in order.
    const orderedAccounts = Object.values(resolvedAccounts).sort((a, b) => a.index - b.index);
    // Keys and Signers.
    const [keys, signers] = (0, shared_1.getAccountMetasAndSigners)(orderedAccounts, 'omitted', programId);
    // Data.
    const data = getApproveUseAuthorityInstructionDataSerializer().serialize(resolvedArgs);
    // Bytes Created On Chain.
    const bytesCreatedOnChain = 0;
    return (0, umi_1.transactionBuilder)([
        { instruction: { keys, programId, data }, signers, bytesCreatedOnChain },
    ]);
}
exports.approveUseAuthority = approveUseAuthority;
//# sourceMappingURL=approveUseAuthority.js.map